import { normalizeSchoolYearStartYear } from "../common/schoolYear";

export function getNormalizedSchoolYearStartYearFromSearch(search, today = new Date()) {
  const params = new URLSearchParams(search || "");
  return normalizeSchoolYearStartYear(params.get("schoolYearStart"), today);
}

export function buildSearchWithSchoolYear(search, startYear) {
  const params = new URLSearchParams(search || "");
  params.set("schoolYearStart", String(startYear));
  const nextSearch = params.toString();

  return nextSearch ? `?${nextSearch}` : "";
}

export function buildManageRouteWithSchoolYear(pathname, search, startYear) {
  return {
    pathname,
    search: buildSearchWithSchoolYear(search, startYear),
  };
}

export function pushManageRouteWithSchoolYear(history, pathname, search, startYear, state) {
  history.push({
    ...buildManageRouteWithSchoolYear(pathname, search, startYear),
    ...(state ? { state } : {}),
  });
}
